import { render, staticRenderFns } from "./studentsBySocialProject.vue?vue&type=template&id=735be0dc&"
import script from "./studentsBySocialProject.js?vue&type=script&lang=js&"
export * from "./studentsBySocialProject.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports